module.exports = __webpack_public_path__ + "img/referral_expired.f9e663c0.svg";